import { Avatar, Menu, MenuItem, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import { useSession } from '../../auth/useSession';

export const Profile = () => {
  const { userInfo, userRole, deleteSession } = useSession();
  const userImage =
    sessionStorage.getItem('ACP-picture') || '/static/images/avatar/2.jpg';
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
  const settings = ['Logout'];

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleMenuOption = (event: React.MouseEvent<HTMLElement>) => {
    const option = (event.target as HTMLInputElement).innerText;
    if (option === 'Logout') {
      handleLogout();
    }
  };

  const handleLogout = () => {
    deleteSession();
    window.location.href = '/login';
  };

  useEffect(() => {
    // Fetch user data
  }, []);

  return (
    <Box sx={{ flexGrow: 0 }}>
      <div
        className="flex cursor-pointer items-center justify-center"
        onClick={handleOpenUserMenu}
      >
        <Avatar alt="user_avatar" src={userImage} />
        <div className="mx-4 flex flex-col items-start justify-start">
          <Typography sx={{ color: 'text.primary' }}>
            {userInfo?.userName}
          </Typography>
          <Typography sx={{ color: 'text.primary' }}>{userRole}</Typography>
        </div>
      </div>
      <Menu
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClick={handleMenuOption}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        {settings.map((setting) => (
          <MenuItem key={setting} onClick={handleCloseUserMenu}>
            <Typography sx={{ textAlign: 'center' }}>{setting}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};
